module.exports = __webpack_public_path__ + "static/media/slide4.4c80e79f.webp";